import { useSkillGroupList, useSubSkillGroupList } from 'components/company/api/useCompetencyAndSkillGroup';
import { CompetencyLibrary } from 'components/types/company';
import { useEffect, useMemo } from 'react';

const UseFetchData = ({
  setInitialValuesMod, initialValues, typeForm, data, modal, skillGroup,
}: CompetencyLibrary) => {
  const companyId = localStorage.getItem('company_id');
  const skillGroupId = {
    create: skillGroup?.tempData?.competency_detail?.[0]?.competency_group ?? undefined,
    edit: skillGroup?.data?.competency_detail?.[0]?.competency_group ?? undefined,

  };

  const { data: skillGroupRaw, isFetching: keyListSkillGroup } = useSkillGroupList(companyId, Boolean(modal));

  const { data: subSkillGroupRaw, isFetching: keySubSkillGroup } = useSubSkillGroupList(skillGroupId[typeForm], Boolean(skillGroupId));

  const listSkillGroup = useMemo(() => skillGroupRaw?.filter((val) => val.status === 'active').map((item) => ({
    value: item.competency_skill_group_id,
    label: item.skill_group_name,
  })), [skillGroupRaw]);

  const listSubSkillGroup = useMemo(() => subSkillGroupRaw?.filter((val) => val.status === 'active').map((item) => ({
    value: item.competency_sub_skill_group_id,
    label: item.sub_skill_group_name,
  })), [subSkillGroupRaw]);

  // CREATE COMP LIBRARY

  useEffect(() => {
    setInitialValuesMod(initialValues);
    if (typeForm === 'edit' && data && modal) {
      const output = {
        competency_detail: [],
      };
      const competencyTypeMap = {};
      data?.competency_detail?.forEach((item) => {
        if (!competencyTypeMap[item.competency_type]) {
          competencyTypeMap[item.competency_type] = {
            competency_type: item.competency_type,
            competency_group: item.competency_group,
            description_sub_skill: item.description_sub_skill,
            showDataSubSkill: [],
            detail: [],
          };
          output.competency_detail.push(
            competencyTypeMap[item.competency_type],
          );
        }
        competencyTypeMap[item.competency_type].detail.push({
          competency_detail_id: item.competency_detail_id,
          competency_id: item.competency_id,
          competency_level: item.competency_level,
          value: item.value,
          performance_criteria: item.performance_criteria,
          experience: item.experience,
          learning_development: item.learning_development,
          evidence: item.evidence,
          order: item.order,
        });
      });

      setInitialValuesMod({
        tempData: {
          title: data.title,
          competency_detail: initialValues.tempData.competency_detail,
        },
        data: {
          title: data.title,
          competency_detail: output?.competency_detail,
        },
      });
    } else {
      setInitialValuesMod({
        tempData: {
          title: '',
          competency_detail: [initialValues.tempData.competency_detail[0]],
        },
        data: {
          title: '',
          competency_detail: [],
        },
      });
    }
    return () => {
      setInitialValuesMod(initialValues);
    };
  }, [data, typeForm, modal]);

  return ({
    listSkillGroup,
    listSubSkillGroup,
    skillGroupRaw,
    subSkillGroupRaw,
    keyListSkillGroup,
    keySubSkillGroup,
  });
};

export default UseFetchData;
